<template>
    <ol type="a">
        <li
            v-for="(answer, idx) in explanation.answers"
            :key="idx"
            :class="{
                'error--text': ! isAnswerHidden && ! answer.correct && explanation.user_answer == answer.answer,
                'primary--text font-weight-bold': ! isAnswerHidden && answer.correct,
                'font-weight-bold': isAnswerHidden && explanation.user_answer === answer.answer,
            }"
        >
            {{ answer.answer }}

            <template v-if="! isAnswerHidden && explanation.user_answer == answer.answer">
                <v-icon
                    v-if="! isAnswerHidden && explanation.user_answer === explanation.correct_answer"
                    color="primary"
                >
                    mdi-check
                </v-icon>

                <v-icon
                    v-else
                    color="red"
                >
                    mdi-close
                </v-icon>
            </template>
        </li>
    </ol>
</template>

<script>
import moment, { parseFromServer } from '@/plugins/moment'

export default {
   props: {
       explanation: {
           type: Object,
           required: true
       },
       hidings: {
           type: Array,
           required: true
       },
       tryoutHidings: {
           type: Array,
           required: true
       }
   },

    computed: {
        appliedHidings() {
            return this.hidings
                .filter((hiding) => this.explanation.hidings.includes(hiding.id))
                .concat(this.tryoutHidings)
        },

        isAnswerHidden() {
            return this.appliedHidings
                .some(hiding => hiding.is_answer_hidden && (! hiding.open_at || parseFromServer(hiding.open_at) > moment()))
        }
    }
}
</script>
